import { Card, Spinner } from "flowbite-react";
import { sortByDate, StatusBadge } from "../../helpers/creditBonus/helper";

const CampaignCard = ({
  data = [],
  isLoading = false,
  selected,
  setSelected,
  showingItems,
}) => {
  return (
    <Card className="flow-root">
      <ul className="divide-y divide-gray-200 dark:divide-gray-700">
        {isLoading ? (
          <li className="py-6 flex justify-center">
            <Spinner />
          </li>
        ) : data.length === 0 ? (
          <li className="py-4 text-sm text-gray-400">Nothing here yet...</li>
        ) : (
          sortByDate(data)
            .slice(0, showingItems)
            .map((c) => (
              <li
                key={c.id}
                onClick={() => setSelected(c)}
                className={`py-3 sm:py-4 cursor-pointer rounded-lg px-2 -mx-2 transition-colors
                        ${
                          selected?.id === c.id
                            ? "bg-blue-50 dark:bg-blue-900/20"
                            : "hover:bg-gray-50 dark:hover:bg-gray-700/40"
                        }`}
              >
                <div className="flex items-start justify-between gap-2">
                  <div className="min-w-0 flex-1">
                    <p className="text-sm font-semibold text-gray-900 dark:text-white truncate">
                      {c.promo_name}
                    </p>
                    <p className="text-xs font-semibold text-gray-400 mt-0.5">
                      {c.start_date} → {c.end_date}
                    </p>
                    <p className="text-xs text-gray-400 mt-0.5">
                      Last updated:{" "}
                      {c.updatedAt.toDate().toLocaleDateString("en-AU", {
                        day: "numeric",
                        month: "short",
                        year: "numeric",
                      })}
                    </p>
                  </div>
                  <StatusBadge status={c.status} />
                </div>
              </li>
            ))
        )}
      </ul>
    </Card>
  );
};

export default CampaignCard;
